module.exports = __webpack_public_path__ + "img/repair-7.c9690b7f.jpg";